import { Node } from "../../node.js";
import { hasName } from "../../role/predicate/has-name.js";
export function hasRole(device, nameOrPredicate = () => true, ...names) {
    let predicate;
    if (typeof nameOrPredicate === "function") {
        predicate = nameOrPredicate;
    }
    else {
        predicate = hasName(nameOrPredicate, ...names);
    }
    return (element) => Node.from(element, device).role.some(predicate);
}
//# sourceMappingURL=has-role.js.map